<div class="summary-loader h-100 w-100 d-flex flex-column justify-content-betwee" *ngIf="showLoader">
  <div class="h-100 p-x-page-thanks d-flex flex-column flex-nowrap justify-content-center" >
    <div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center">
      <img class="loading-image" src="../assets/video/loader.gif">
    </div>
    <div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center">
      <h2 class="accent loading-text">
        {{ "b2c.IDS_LOADING_TEXT" | translate }}
      </h2>
    </div>
  </div>
</div>
<div class="summary-view p-t-block d-flex .flex-column h100" *ngIf="!showLoader" [ngClass]="showSidebar ? 'd-none-always' : ''">
  <div class="row-1">
    <div class="justify-content-center">
      <div class="justify-content-center homewifi-cont">
        <div class="justify-content-center">
          <span class="d-inline-block v-align-center line-height-20 cursor-pointer" (click)="reviewBtnClick()">
            <i class="bticino-ico eye black v-align-center line-height-20 eye-i"></i>
            <span class="line-height-20">
              {{ "b2c.IDS_REVIEW" | translate }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row-2 bg-white h-100" >
    <form class="summary-form form-white justify-content-center" [formGroup]="summaryFormGroup" id="summaryForm"><!--  [eventTracker]="analyticsSummaryEditCall()"-->
        <div class="form-row d-flex flex-column justify-content-left p-l-80">
          <div class="div-name-surname">
            <mat-form-field
              appearance="standard"
              color="accent"
              class="m-l-mobile"
            >
              <mat-label class="input-label">{{'b2c.IDS_NAME' | translate }}</mat-label>
              <input matInput class="form-control" (input)="analyticsSummaryEditCall()" type="text" id="input-name" formControlName="name" placeholder="{{'b2c.IDS_NAME' | translate }}">
            </mat-form-field>

            <mat-form-field
              appearance="standard"
              color="accent"
              class="m-l-mobile"
            >
              <mat-label class="input-label">{{'b2c.IDS_SURNAME' | translate }}</mat-label>
              <input matInput class="form-control" (input)="analyticsSummaryEditCall()" type="text" id="input-surname" formControlName="surname" placeholder="{{'b2c.IDS_SURNAME' | translate }}">
            </mat-form-field>

            <mat-form-field
              appearance="standard"
              color="accent"
              class="m-l-mobile"
            >
              <mat-label class="input-label">{{'b2c.IDS_EMAIL' | translate }}</mat-label>
              <input matInput class="form-control" (input)="analyticsSummaryEditCall()" type="email" id="input-email" formControlName="email" placeholder="{{'b2c.IDS_EMAIL' | translate }}">
            </mat-form-field>
          </div>


          <div class="d-flex flex-row flex-nowrap align-items-center m-t-20">
            <mat-checkbox
              class="d-inline-block"
              id="input-privacy"
              formControlName="privacy"
              color="accent"
            >
            </mat-checkbox>
            <span class="d-inline-block p-l-16 f-size m-w-privacy-chk">
              {{ "b2c.IDS_PRIVACY_CHK" | translate }} &nbsp;<a [routerLink]="" queryParamsHandling="preserve" class="accent" href="mailto:privacy@pec.bticino.it">privacy@pec.bticino.it</a>
            </span>
          </div>
          <div class="d-flex flex-row flex-nowrap align-items-center m-t-24">
            <mat-checkbox
              class="d-inline-block"
              id="input-marketing"
              formControlName="marketing"
              color="accent"
            >
          </mat-checkbox>
          <span class="d-inline-block p-l-16 f-size m-w-privacy-chk">
            {{ "b2c.IDS_MARKETING_CHK" | translate }}
          </span>
          </div>
        </div>
    </form>
  </div>
</div>

<app-lateral-panel id="{{lateralPanelId}}" class="subtitle-info-lateral secondary" [extraClasses]="'summary m-w-768'" [(showSidebar)]="showSidebar">
  <div class="row d-flex justify-content-between align-items-center button-row exit-row panel-title">
    <h3>{{ "b2c.IDS_YOUR_CHOICES" | translate }}</h3>
    <button
      mat-flat-button
      class="bticino-ico close round-button-with-background transparent-background"
      style="width: 40px; height: 40px"
      (click)="onCloseTooltip()"
    >
    </button>
  </div>
  <div class="summary-choices-box m-t-60 panel-description">
      <h4 class="summary-section-title">{{ "b2c.IDS_YOUR_ROOMS" | translate }}</h4>
      <ul>
        <li *ngFor="let room of ds.getSelectedRooms()"><b>{{ room.SubRooms[0].Quantity }}</b>  {{ room.RoomGroupName | translate }}</li>
      </ul>
  </div>
  <div class="summary-choices-box m-t-24 panel-description">
    <h4 class="summary-section-title">{{ "b2c.IDS_YOUR_SYSTEMS" | translate }}</h4>
    <ul>
      <li *ngFor="let sys of ds.getSystems(true)">
        {{ sys.Description+'_B2C' | translate }}
        <ul *ngIf="sys.ID == 10">
          <ng-container *ngFor="let entry of ds.getInternalUnit();">
            <li *ngIf="entry.quantity > 0">
              <b>{{entry.quantity}}</b> {{ entry.name | translate }}
            </li>
          </ng-container>
        </ul>
        <ul *ngIf="sys.ID == 5">
          <ng-container *ngFor="let entry of ds.getSmartThermo();">
            <li>
              <b>{{entry.quantity}}</b> {{ entry.lateralPanelTitle | translate }}
            </li>
          </ng-container>
          <ng-container *ngFor="let entry of ds.getSmartThermoAddon();">
            <li *ngIf="entry.quantity > 0">
              <b>{{entry.quantity}}</b> {{ entry.lateralPanelTitle | translate }}
            </li>
          </ng-container>
        </ul>
        <ul *ngIf="sys.ID == 4">
          <ng-container *ngFor="let entry of ds.getSmartCamera();">
            <li *ngIf="entry.quantity > 0">
              <b>{{entry.quantity}}</b> {{ entry.lateralPanelTitle | translate }}
            </li>
          </ng-container>
          <ng-container *ngFor="let entry of ds.getSmartCameraAddon();">
            <li *ngIf="entry.quantity > 0">
              <b>{{entry.quantity}}</b> {{ entry.lateralPanelTitle | translate }}
            </li>
          </ng-container>
        </ul>
      </li>
    </ul>
  </div>
  <div class="summary-choices-box m-t-24 panel-description" *ngIf="!(ds.getBoolHavingBTicino() && ds.whatToDoIsUpdateImplant())">
      <h4 class="summary-section-title">{{ "b2c.IDS_FINISHING" | translate }}</h4>
      <div class="summary-finishing-image">
        <div class="result" [ngClass]="{'livinglight': ds.getFinishingID() == 3}">
          <div class="black-background" *ngIf="ds.getFinishingID() != 4"></div>
          <img class="plate-img" [src]="plateUrl" *ngIf="plateUrl">
          <div class="buttons" *ngIf="switchesUrl">
              <img [src]="switchesUrl">
          </div>
        </div>
      </div>
      <div>
        <p>{{'b2c.IDS_SERIES' | translate }}: <b> {{ ds.getFinishing().name | translate}}</b></p>
        <p>{{'b2c.IDS_PLATE' | translate }}: <b *ngIf="ds.getPlate()">{{ ds.getPlate().Color | translate }}</b></p>
        <p>{{(ds.getFinishingID() == 4 ? 'b2c.IDS_COVER' : 'b2c.IDS_BUTTON') | translate }}: <b *ngIf="ds.getSwitch()">{{ ds.getSwitch().name | translate }}</b></p>
      </div>
    </div>
    <div class="bottom-filler"></div>
</app-lateral-panel>
